import SpotUtils from 'utils/spot';

export default function getTopSearchResults({
    filters,
    spots,
    isMonthly,
    airport,
    sortBy,
}) {
    const filteredSpots = filters
        ? SpotUtils.sortByAttribute(
              SpotUtils.filter(spots, filters, isMonthly),
              sortBy
          )
        : spots;

    return {
        filteredSpots,
        topSpots: filteredSpots.map(({facility: {id, tag}}) => ({
            facility_id: id,
            ...(airport && {tag}),
        })),
    };
}
